/**Minimum number of items in the result of the cross sell smart collection. */
export const MIN_ITEMS_IN_CROSS_SELL_RESULT = 2;
